import { AppLayout } from "@/components/layout/AppLayout";
import { NotificationsCenter } from "@/components/NotificationsCenter";

export default function Notifications() {
  return (
    <AppLayout title="Notifications">
      <NotificationsCenter className="max-w-3xl" />
    </AppLayout>
  );
}
